import React from "react";
import Skeleton from "../../ui-components/Skeleton/Skeleton";

const OrderRecapSkeleton = ({ type, hasSkipButton, coupon }) => {
    return (
        <>
            {/* Body */}
            <div className="w-100%">
                <div className="d-flex justify-between items-start" style={{ padding: '12px', marginBottom: '12px' }}>
                    <div className="d-flex flex-column items-end gap-base2" style={{ width: '100px', marginRight: '12px' }}>
                        <Skeleton height={80} width={'100px'} classNames='radius-xs' />
                    </div>
                    <div className="d-flex flex-column items-start w-100% gap-base2">
                        <Skeleton height={16} width={'65%'} classNames='radius-xs' />
                        <Skeleton height={16} width={'100%'} classNames='radius-xs' />
                        <Skeleton height={16} width={'100%'} classNames='radius-xs' />
                        <Skeleton height={16} width={'100%'} classNames='radius-xs' />
                    </div>
                </div>

                <div className="d-flex justify-between items-start" style={{ padding: '0 12px' }}>
                    <div className="d-flex flex-column items-start w-100% gap-base2" style={{ gap: '12px' }}>
                        <Skeleton height={16} width={'100%'} classNames='radius-xs' />
                        <Skeleton height={16} width={'90%'} classNames='radius-xs' />
                    </div>
                    <div className="d-flex flex-column items-end w-100% gap-base2">
                        <Skeleton height={16} width={'30%'} classNames='radius-xs' />
                    </div>
                </div>

                <hr className="w-100% border-b-secondary-50" />

                <div class="d-flex justify-between items-center" style={{
                    padding: '0 12px',
                    justifyContent: 'flex-start',
                }}>

                    <div style={{ marginRight: '12px' }}>
                        <Skeleton height={25} width={30} classNames='radius-xs' />
                    </div>
                    <div className="d-flex flex-column items-start w-100% gap-base2" style={{ gap: 12 }}>
                        <Skeleton height={16} width={100} classNames='radius-xs' />
                        <Skeleton height={12} width={110} classNames='radius-xs' />
                    </div>
                </div>
            </div>

            <div style={{ marginTop: '20px' }}>
                <Skeleton height={67} width={"100%"} borderRadius={'0 0 8px 8px'} />
            </div>
        </>
    )
};

export default OrderRecapSkeleton;
